// extracted by mini-css-extract-plugin
export default {"img1":"Home_img1__vMjsS","img":"Home_img__sWeAJ","jobCardCont":"Home_jobCardCont__S-3xV","main":"Home_main__19nnz","btn":"Home_btn__YEDqX","link":"Home_link__VSzyp"};